require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-lastingloyalty.json") })
        }
      }, "path---es-articles-lastingloyalty");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-lastingloyalty!./.cache/json/es-articles-lastingloyalty.json
// module id = 2218
// module chunks = 231608221292675